var _module = require('../../module');

require('../../../services/edit-user-property-modal');
require('../../../services/delete-user-modal');
require('../../../services/thankyou-modal');
require('../../../services/error-modal');
require('../../../services/analytics');

_module.component('editProfile', {
    controllerAs: 'editProfile',
    controller: [
        '$log',
        '$timeout',
        '$stateParams',
        '$user',
        '$verifyModal',
        '$editUserPropertyModal',
        '$deleteUserModal',
        '$filter',
        '$thankyouModal',
        '$errorModal',
        '$analytics',

        function name($log, $timeout, $stateParams, $user, $verifyModal, $editUserPropertyModal, $deleteUserModal, $filter, $thankyouModal, $errorModal, $analytics) {
            var _this = this;

            var initUserObj = function () {
                _this.usr = $user;
            };

            var trackProfileEditEvent = function (keyName) {
                var capKey = $filter('capitalize')((keyName||'').replace('full_',''));
                var eventName = 'Profile Edit Save Click';
                var eventData = {
                    'Source': capKey
                };

                $analytics.eventTrack(eventName, eventData);
            };

            var init = function () {
                initUserObj();
            };

            init();

            /// PUBLIC API

            _this.editUserProperty = function (keyName) {
                if(keyName) {
                    $editUserPropertyModal(keyName, _this.usr[keyName])
                        .then(function (response) {
                            initUserObj();
                            trackProfileEditEvent(keyName);
                            if(response && response.msg) {
                                $thankyouModal(response.msg);
                            }
                        })
                        .catch(function (err) {
                            $log.error('EditUserProperty Save Error', err);
                            $errorModal();
                        });
                }
            };

            _this.handleDeleteClick = function () {
                var _deleteUser = function (response) {
                    $user.delete(response || 'n/a')
                    .then(function (response) {
                        return $thankyouModal(
                            'Your nest.me account has been successfully deleted.',
                            { title: 'Goodbye!' }
                            ).result;
                    })
                    .then(function () {
                        $user.logout();
                    })
                    .catch(function (err) {
                        $log.error('Delete User error', err);
                        $errorModal();
                    });
                };

                $deleteUserModal()
                    .then(function (response) {
                        // deleteUserModal returns false if the user cancelled deletion
                        if(response === false) return;
                        // deleteUserModal returns the "reason" for cancellation as a string if the user opted to cancel
                        _deleteUser(response);
                    })
                    .catch(function (err) {
                        $log.error('DeleteUser error', err);
                        $errorModal();
                    });
            };
        }
    ],
    template: require('./index.html')
});
